import React, { useContext, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector, useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { useTranslation } from 'react-i18next';
import CardItem from './CardItem';
import { Context } from './ContextWrapper';
import { fetchProductGroup } from '../Store/SystemMasters.action';

function CardContent() {
  const { cards } = useContext(Context);
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const csList = useSelector((state) => state);
  const {
    UserDetails: { userInfo },
  } = csList;

  useEffect(() => {
    if (userInfo.userId) {
      dispatch(fetchProductGroup(t));
    }
  }, [dispatch, userInfo]);

  return (
    <PerfectScrollbar>
      <ul>
        {cards.map((card, index) => (
          <CardItem key={card?._id || index} index={index} item={card} />
        ))}
      </ul>
    </PerfectScrollbar>
  );
}

export default CardContent;
